import {
  ContentSwitcher,
  GridViewIcon,
  TableViewIcon,
  type ContentSwitcherSize,
} from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";

/** 목록 화면의 보기 방식 — 카드 그리드 또는 표. */
export type ViewMode = "grid" | "table";

export const VIEW_MODES: readonly ViewMode[] = ["grid", "table"];

export function isViewMode(value: unknown): value is ViewMode {
  return typeof value === "string" && (VIEW_MODES as readonly string[]).includes(value);
}

type ViewModeToggleProps = {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
  /** 세그먼트 묶음의 접근 이름. 목록마다 무엇의 보기인지 말한다. */
  label: string;
  /** `md`(기본)는 옆의 md 컨트롤과, `sm` 은 도구 띠의 sm 버튼과 높이를 맞춘다. */
  size?: ContentSwitcherSize;
  className?: string;
};

/**
 * 그리드/표 전환 — c6 `ContentSwitcher` 의 아이콘 전용 세그먼트. 목록 도구 띠의 오른쪽 끝에 선다
 * (규칙 §13 의 목록 도구 자리).
 */
export function ViewModeToggle({
  value,
  onChange,
  label,
  size = "md",
  className,
}: ViewModeToggleProps): ReactNode {
  return (
    <ContentSwitcher
      label={label}
      size={size}
      value={value}
      onValueChange={(next) => {
        if (isViewMode(next)) {
          onChange(next);
        }
      }}
      className={className}
      options={[
        { value: "grid", icon: <GridViewIcon />, ariaLabel: "그리드 보기" },
        { value: "table", icon: <TableViewIcon />, ariaLabel: "표 보기" },
      ]}
    />
  );
}
